import React from 'react';
import { Button, Space, Row, Typography, Alert, } from 'antd';
import { Modal } from '../../UI/Modal/Modal.component';
import { UserOutlined, } from '@ant-design/icons';
import { enableUser } from '../../../services/UserService';
import { useNotificationApi } from '../../UI/NotificationProvider';

const { Paragraph } = Typography;

export const ActivateUserModal = ({displayModal, setDisplayModal, user, refreshData, setRefreshData}) => {

    const notificationApi = useNotificationApi();

    const activateUser = () => {
        enableUser(user).then(response => {
            if(response.result){       
                setRefreshData(true);
                setTimeout(() => {
                    notificationApi['success']({
                        message: 'Success',
                        description: `User ${user.username} is now active.`,  
                        duration: 6,
                    });
                }, 2000)
                setDisplayModal(false);
            }
        })
    }

    return (
        <>
            { !refreshData &&
                <Modal 
                    title={'Activate User'}
                    visible={displayModal} 
                    setVisible={setDisplayModal}
                    justifyTitle={'middle'}
                    actionGroup={false}
                    >
                    <Space direction='vertical'>
                        <Alert
                            message={
                                <code>
                                    <strong>Username: </strong><br/>{user?.username}<br/>
                                </code>}
                            closable={false}
                            style={{textAlign: 'center'}}
                        />
                        <Paragraph style={{textAlign: 'center'}}>You're about to activate this user account. Are you sure you want to proceed?</Paragraph>
                        <Row justify='end' gutter={[12,12]}>
                            <Space>
                            <Button onClick={() => setDisplayModal(false)}>Cancel</Button>
                            <Button icon={<UserOutlined />} type='primary' onClick={() => activateUser()}>Yes, activate user</Button>
                            </Space>
                        </Row>
                    </Space>
                </Modal>
            }
        </>
    )
}
